module.exports = __webpack_public_path__ + "img/管车助手.91389108.png";